var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"outlined":"","color":"purple"}},[_c('div',{staticClass:"text-h6"},[_vm._v("Базовый срок")]),_c('div',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }